// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';

import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


class CollectionDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    const game = params.getAll('game_type')
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      game_type: game,
      date: params.get('date'),
      collection_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      excel_data:[],
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    var game_type = this.state.game_type;
    var game_str = '';
    if(game_type.length > 1){
      game_str = `game_type_id=${game_type[0]}&game_type_id=${game_type[1]}`
    }
    else{
      game_str = `game_type_id=${game_type[0]}`
    }
    this.getCustomers(this.state.venue,game_str);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getCustomers(venue,game_type) {
    
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=751338&venue_id=${venue}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({collection_data:data.data,headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  renderCutsomers(){
    var excelName = this.state.date +' collection'
    var venue = this.state.venue;
    var headers = []
    if(this.state.headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.headers.length; i++) {
        if(this.state.headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.headers[i]);
          tab_index.push(i);
        }
      }
    }
    
    return(
      <div> 
      <div style={{float:'right',marginBottom:'1%'}}>
     

        <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button btn btn-primary"
                    table="table-to"
                    filename={excelName}
                    sheet={excelName}
                    buttonText="Download as XLS"/>


      </div>      
      <div className='col-md-12 table_container1 table-responsive' style={styles.table}>

        <div className="heading heading2 left" style={styles.header}>Daily Collection</div> 

        { this.state.collection_data.length > 0 ?
        <table id="table-to-xls" className="table_plain" style={{marginBottom:'1%'}}>
          <tr> 
            {headers.map((head)=>
              <th>{head}</th>
            )
          }
          </tr>
          
            { this.state.collection_data && this.state.collection_data.length > 0 ?
              this.state.collection_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.customer_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      
          :
          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }

        
   
      </div>

      <table id="table-to" style={{opacity:'0',height:'10%'}}>
                    <tr> 
            {headers.map((head)=>
              <th>{head}</th>
            )
          }
          </tr>
          
              {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
          
                </table>
          </div>
      )
  }

  render() {
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('collection_data',this.state.collection_data)
    return(
      <div>
        
        <div>
            
             <div className="breadcrumps" style={{marginBottom:'2%'}}>
                        <a href={'/#/dashboard/ActiveCustomer'} >
                          <span>Dashboard</span>
                        </a> 
                        <a href={'/#/dashboard/CollectionDetails'} >
                          <span>Collection Details </span>
                        </a>
                        <a>
                          <span>Daily Collections</span>
                        </a>  
            </div>
          {this.renderCutsomers()}
        </div>
      </div>
    );
  }
}

export default CollectionDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/CollectionDetails/CollectionDetails.js